// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"77":"95febe34","144":"e37bde02","265":"590c7c84","396":"b7cba977","615":"947bbcac","629":"35880474","727":"33dbf504","756":"1bdf9521","814":"b5978e88","815":"4da92ed1","953":"f8c3c779","978":"854fba80"}[chunkId] + ".chunk.js";
};